var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 82,
    viewBox: "0 0 92 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.608,9.274v.132a9.5,9.5,0,0,0,3.046,6.86,28.477,28.477,0,0,1,8.573,20.766v.327c0,14.88-10.132,27.308-26.146,27.308-15.36,0-26.308-12.592-26.308-27.635V36.7c0-8.324,3.1-15.843,8.56-20.9a9.261,9.261,0,0,0,3.057-6.77h0A9.029,9.029,0,0,0,16.68,2.022,44.7,44.7,0,0,0,0,37.032v.327C0,61.887,19.446,82,45.755,82,72.392,82,92,61.56,92,37.032V36.7A44.234,44.234,0,0,0,75.634,2.062,9.239,9.239,0,0,0,60.608,9.274Z",
    transform: "translate(92 82) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e3da141de1c58d1b2db9720e621e2b54.svg";
export { ForwardRef as ReactComponent };